import { useEffect, useState } from "react";
import { Loader2, CalendarClock } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Textarea } from "../ui/textarea";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export default function LeadNotesDialog({ lead, onClose, onSave }) {
  const [notes, setNotes] = useState("");
  const [date, setDate] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (lead) {
      setNotes(lead.notes || "");
      setDate(lead.next_action_at || "");
    }
  }, [lead]);

  const save = async () => {
    setBusy(true);
    const ok = await onSave(lead.id, { notes, next_action_at: date || undefined, clear_next_action: !date });
    setBusy(false);
    if (ok) onClose();
  };

  return (
    <Dialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="lead-notes-dialog" className="bg-cream border-navy/10 sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-navy font-medium tracking-tight">Follow-up · {lead?.name}</DialogTitle>
          <DialogDescription className="text-charcoal/70 font-body">{lead?.company ? `${lead.company} · ` : ""}{lead?.category}</DialogDescription>
        </DialogHeader>
        <div className="space-y-5 pt-2">
          <div className="space-y-1.5">
            <Label htmlFor="lead-notes" className="text-navy">Notes</Label>
            <Textarea data-testid="lead-notes-input" id="lead-notes" rows={6} value={notes} onChange={(e) => setNotes(e.target.value)}
              placeholder="Call summary, quote sent, samples dispatched…" className="bg-white border-navy/15 resize-none" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="lead-next-action" className="text-navy flex items-center gap-2"><CalendarClock size={14} strokeWidth={1.5} /> Next action date</Label>
            <div className="flex gap-2">
              <Input data-testid="lead-next-action-input" id="lead-next-action" type="date" value={date} onChange={(e) => setDate(e.target.value)} className="bg-white border-navy/15" />
              {date && <button type="button" data-testid="lead-next-action-clear" onClick={() => setDate("")} className="text-xs text-navy/60 hover:text-navy px-2">Clear</button>}
            </div>
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" data-testid="lead-notes-cancel" onClick={onClose} className="rounded-full border border-navy/20 px-5 py-2.5 text-sm text-navy hover:bg-navy/5 transition-colors">Cancel</button>
            <button type="button" data-testid="lead-notes-save" onClick={save} disabled={busy}
              className="inline-flex items-center gap-2 rounded-full bg-navy text-ivory px-6 py-2.5 text-sm font-semibold hover:opacity-90 transition-opacity disabled:opacity-60">
              {busy && <Loader2 size={14} className="animate-spin" />} Save
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
